

























import { Component, Vue, Prop } from 'vue-property-decorator'
import vSelect from 'vue-select'
import debounce from 'debounce'
import { SourceCodeServiceUser } from '@/services/sourceCode/SourceCodeService'
import { useSourceCodeUsers, useSourceCodeUsersReturn } from '@/store/modules/sourceCode/users'
import { useSourceCodeInfo } from '@/store/modules/sourceCode/info'
import ErrorMessage from '@/components/ErrorMessage/index.vue'

import 'vue-select/dist/vue-select.css'

@Component({
  components: {
    vSelect,
    ErrorMessage
  },
  setup () {
    const {
      searchUsersByTerm,
      users: options,
      errorMessage,
      hasError,
      isLoading
    } = useSourceCodeUsers()
    const { name: serviceName } = useSourceCodeInfo()

    return {
      searchUsersByTerm,
      options,
      serviceName,
      errorMessage,
      hasError,
      isLoading
    }
  }
})
export default class UserSelect extends Vue {
  @Prop(Object) readonly value!: SourceCodeServiceUser

  serviceName!: string
  options!: useSourceCodeUsersReturn['users']
  searchUsersByTerm!: useSourceCodeUsersReturn['searchUsersByTerm']
  hasError!: useSourceCodeUsersReturn['hasError']
  isLoading!: useSourceCodeUsersReturn['isLoading']
  errorMessage!: useSourceCodeUsersReturn['errorMessage']

  get label(): string {
    return `Select a ${this.serviceName} user:`
  }

  get placeholder(): string {
    return `Type a ${this.serviceName} user...`
  }

  onSearch = debounce(this.search, 350)

  async search(search: string): Promise<void> {
    if (search.trim()) {
      this.searchUsersByTerm(search)
    }
  }

  handleInput(valueSelected: SourceCodeServiceUser | null): void {
    this.$emit('input', { ...valueSelected })
  }
}
